import {
    createRegisterableComponentWithData,
    ElectionDataLoader,
} from '@news-mono/web-common'
import React from 'react'
import { TheSeatsWidget } from './TheSeatsWidget'

type SeatWidgetRouteProps = {
    electoratePageUrl: string
    seatDisplayCount?: number
    headingLevel?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
    titleText?: string
}
export const SeatWidgetRegistration = createRegisterableComponentWithData(
    'election-seat-widget',
    ElectionDataLoader,
    (props: SeatWidgetRouteProps, data, services) => {
        return (
            <TheSeatsWidget
                data={data}
                onEvent={services.onEvent}
                electoratePageUrl={props.electoratePageUrl}
                seatDisplayCount={props.seatDisplayCount}
                headingLevel={props.headingLevel}
                titleText={props.titleText}
                imageBaseUrl={services.config.imageBaseUrl}
            />
        )
    },
)
